import React, { useMemo } from "react";
import { geoNaturalEarth1, geoPath } from "d3-geo";
import { feature } from "topojson-client";
import world from "../lib/world-110m.json";
import { A2_TO_NUM } from "../lib/isoNumeric";

const WIDTH = 640;

export function WorldMap({ data = [], height = 300 }) {
  const features = useMemo(
    () => feature(world, world.objects.countries).features,
    []
  );
  const path = useMemo(() => {
    const projection = geoNaturalEarth1().fitSize([WIDTH, height], {
      type: "FeatureCollection",
      features,
    });
    return geoPath(projection);
  }, [features, height]);

  const { counts, max } = useMemo(() => {
    const m = {};
    let mx = 0;
    for (const d of data) {
      const num = A2_TO_NUM[(d.country || "").toUpperCase()];
      if (!num) continue;
      m[num] = (m[num] || 0) + d.count;
      if (m[num] > mx) mx = m[num];
    }
    return { counts: m, max: mx };
  }, [data]);

  const fill = (id) => {
    const c = counts[id];
    if (!c) return "#f1f5f9";
    const t = max ? c / max : 0;
    return `rgba(220,38,38,${(0.3 + t * 0.65).toFixed(2)})`;
  };

  return (
    <svg viewBox={`0 0 ${WIDTH} ${height}`} className="w-full h-auto" role="img"
      aria-label="Visitor world map" data-testid="visitor-world-map">
      {features.map((f) => {
        const id = String(f.id);
        const c = counts[id];
        return (
          <path key={id} d={path(f)} fill={fill(id)} stroke="#cbd5e1" strokeWidth={0.4}
            data-testid={c ? `map-country-${id}` : undefined}>
            <title>{f.properties?.name}{c ? `: ${c}` : ""}</title>
          </path>
        );
      })}
    </svg>
  );
}
